import { createRouteRef } from '@backstage/frontend-plugin-api';

/** The « Coûts plateforme » page. */
export const costsRouteRef = createRouteRef();

/** Its path. */
export const COSTS_PATH = '/couts';
